<div class="container">
  <div class="container__header">
    <button class="close-button" mat-icon-button (click)="close.emit(null)" [tabIndex]="-1">
      <mat-icon [svgIcon]="'close'"></mat-icon>
    </button>
    <div class="container__header__title">Select the View and the Field</div>
  </div>
  <div class="container__field-list">
    <form [formGroup]="form" class="w-full">
      <div class="flex flex-col gt-xs:flex-row w-full">
        <mat-form-field>
          <mat-label>View</mat-label>
          <mat-select formControlName="pipeline_id">
            <mat-option *ngFor="let pipeline of pipelines | filterBy: ['pipeline_type']:'static'" [value]="pipeline.id">
              {{ pipeline.name }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div *ngIf="customFields?.length; else noFields" class="flex flex-col gt-xs:flex-row w-full">
        <mat-form-field>
          <mat-label>Field</mat-label>
          <mat-select formControlName="field_name">
            <mat-option *ngFor="let customField of customFields" [value]="customField.name">
              {{ customField.label }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <ng-template #noFields>
        <div *ngIf="showAddFieldOption" class="w-full text-center">
          Your account doesn't have any field
          <strong>Related To Company</strong>&nbsp;for <strong>Deal</strong> <br />
          Click
          <strong><a class="new-field-button" (click)="openAddFieldForm()" #customFieldPanelOrigin>here</a></strong> to
          add a new field
        </div>
      </ng-template>
    </form>
  </div>
  <div class="container__footer">
    <button mat-button (click)="close.emit(null)">Cancel</button>
    <button mat-flat-button color="primary" (click)="close.emit(form.getRawValue())" [disabled]="!form.valid">
      Next
    </button>
  </div>
</div>
<ng-template #customFieldPanel>
  <app-add-field
    [mentionConfig]="mentionConfig"
    [formValue]="{ type: 'record', record_type: 'Company' }"
    [onlyLabelEditable]="true"
    (fieldAdded)="onFieldAdded($event)"
  ></app-add-field>
</ng-template>
